import { Typography, Card, CardContent, CardHeader, List, ListItem, ListItemText, Box } from '@mui/material';
import { versionLogsData } from '../utils/versionLogsData';
import { format } from 'date-fns';

const renderLegacyFeatures = (features) => (
    <List dense>
        {features?.map((feature, featureIndex) => (
            <ListItem key={featureIndex}>
                <ListItemText primary={feature} />
            </ListItem>
        ))}
    </List>
);

const renderSections = (sections) => (
    <>
        {sections.map((section, sectionIndex) => (
            <Box key={sectionIndex} sx={{ mt: sectionIndex > 0 ? 1.5 : 0 }}>
                <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                    {section.label}
                </Typography>
                <List dense disablePadding>
                    {section.items?.map((item, itemIndex) => (
                        <ListItem key={itemIndex} disableGutters sx={{ pl: 2 }}>
                            <ListItemText primary={item} />
                        </ListItem>
                    ))}
                </List>
            </Box>
        ))}
    </>
);

export const VersionLogs = () => {

    return (
        <Card sx={{ bgcolor: '#FDEFE6', color: 'black', mb: 2 }}>
            <CardHeader title="Release Updates" />
            <CardContent>
                {versionLogsData && versionLogsData?.map((versionLog, index) => (
                    <Card key={index} sx={{ mb: 2 }}>
                        <CardContent>
                            <Typography variant="h6">Version : {versionLog?.version}</Typography>
                            <Typography variant="body2" color="textSecondary">{format(new Date(versionLog?.date), 'dd/MM/yyyy')}</Typography>
                            {versionLog?.sections?.length > 0
                                ? renderSections(versionLog.sections)
                                : renderLegacyFeatures(versionLog?.features)}
                        </CardContent>
                    </Card>
                ))}
            </CardContent>
        </Card>
    );
};